type pricePairMap = { [key: string]: string }

export const pricePairs:pricePairMap = {
    "ETH / USD" : "eth-usd.data.eth",
    "BTC / USD" : "btc-usd.data.eth",
    "BNB / USD" : "bnb-usd.data.eth",
    "LINK / USD" : "link-usd.data.eth",
}

